import {InitialState, Actions, ACTION_TYPES} from "./types";

const initialState: InitialState = {};

const store = (state = initialState, {type, payload}: Actions) => {
    switch (type) {
        case ACTION_TYPES.GET_MY_ORGANISATION_SUCCESS: 
            return {
                ...state,
                [payload.alias]: payload,
            }
        default: 
            return state;
    }
}

export default store;